var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 346,
    viewBox: "0 0 415 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.758 107.986C351.199 109.025 352.541 110.196 353.766 111.483C355.148 110.824 374.891 98.5304 384.099 94.353",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.034 109.047C371.421 117.281 353.867 129.99 350.002 129.99C346.639 129.99 342.635 125.657 339.914 121.974",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.094 313.538L352.834 315.388C352.535 317.501 353.022 319.651 354.204 321.428L353.094 313.538Z",
    fill: "#DFDFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M405.65 35.3547L401.386 34.7481L392.719 33.5217L391.493 42.1884L355.6 295.87L361.736 299.905L355.561 323.027C356.863 324.24 358.508 325.022 360.271 325.268L364.539 325.874C366.835 326.198 369.166 325.597 371.019 324.202C372.872 322.808 374.095 320.735 374.419 318.438L376.681 302.461L413.081 45.2347L414.308 36.5681L405.65 35.3547Z",
    fill: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.453 297.093L361.73 299.905L360.266 305.391L375.948 307.614L377.045 299.866L357.453 297.093Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.868 14.4294L49.6618 41.1304C34.4882 43.94 24.4651 58.5182 27.2746 73.6918L72.4511 317.68C75.2606 332.853 89.8389 342.876 105.013 340.067L249.219 313.366C264.392 310.556 274.416 295.978 271.606 280.805L226.43 36.8166C223.62 21.643 209.042 11.6199 193.868 14.4294Z",
    fill: "#DEDFE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.432 19.8773L22.1895 46.2146L77.5402 345.152L219.782 318.814L164.432 19.8773Z",
    fill: "#DEDFE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.715 10.5765L0.558594 50.9612L77.6029 345.055L231.759 304.671L154.715 10.5765Z",
    fill: "#DEDFE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.388 131.724C249.507 130.753 247.336 128.963 247.336 125.713C247.336 124.322 248.124 122.429 249.394 120.292L223.485 21.423C221.604 14.2577 216.954 8.13282 210.558 4.39488C204.162 0.656939 196.543 -0.388042 189.377 1.48969L27.5969 43.8696C20.4307 45.7508 14.305 50.4012 10.5669 56.7982C6.8289 63.1951 5.78457 70.8148 7.66361 77.9816L70.5618 318.018C72.4421 325.184 77.0916 331.309 83.4878 335.047C89.8841 338.786 97.5032 339.83 104.669 337.951L266.45 295.558C273.616 293.678 279.741 289.028 283.479 282.632C287.218 276.236 288.262 268.617 286.383 261.45L252.388 131.724Z",
    fill: "#DEDFE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.649 5.06934L160.053 10.3777L236.057 305.276L256.654 299.967L180.649 5.06934Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.021 36.5173L32.6348 82.2017L52.9506 159.751L227.337 114.067L207.021 36.5173Z",
    fill: "#F3F3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207.021 36.5173L32.6348 82.2017L52.9506 159.751L227.337 114.067L207.021 36.5173Z",
    fill: "#F3F3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.889 267.367L78.0449 284.878L88.7684 325.812L155.612 308.301L144.889 267.367Z",
    fill: "#B4ACF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.547 6.57275L392.727 33.5217L414.307 36.5768L407.547 6.57275Z",
    fill: "#F3F3F3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M409.775 16.4614L407.548 6.57275L402.664 15.4518L409.775 16.4614Z",
    fill: "#B4ACF9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M328.486 91.1897C336.845 92.325 349.546 103.28 349.98 106.092C350.452 109.151 344.446 119.694 338.453 122.901",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M291.033 88.0997C294.166 84.4122 298.023 81.8253 302.76 80.7637",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M279.67 120.318C279.774 119.512 279.885 118.708 280.004 117.905",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M312.516 80.6121C348.574 86.9387 338.208 166.057 337.597 172.669C334.408 178.151 283.769 184.17 280.718 180.833C280.111 176.305 277.308 153.503 278.703 130.749",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.802 102.287C258.878 107.661 247.334 120.388 247.334 125.713C247.334 131.888 255.173 132.803 260.846 132.803C267.87 132.803 278.807 131.035 284.679 129.336C285.251 132.525 287.448 134.904 290.074 134.904C293.138 134.904 295.621 131.676 295.621 127.694C295.621 123.711 293.138 120.479 290.074 120.479C289.523 120.479 288.977 120.585 288.466 120.791C288.416 120.722 288.351 120.666 288.276 120.627C288.201 120.587 288.118 120.564 288.033 120.561C286.616 120.561 273.191 120.063 271.774 120.31C272.723 119.495 274.106 118.143 275.406 116.843",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M280.018 117.805C279.597 118.117 279.103 118.318 278.584 118.39C275.147 118.39 263.166 105.923 264.47 98.1794C265.774 90.4357 290.072 84.9844 294.123 89.465C300.394 96.3984 285.53 114.33 280.018 117.805",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M302.195 67.8459C302.195 67.8459 302.884 83.5067 302.897 85.721C302.897 87.073 307.738 87.7273 311.49 87.3417",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M311.174 76.0057C311.739 76.0883 312.311 76.1187 312.881 76.0967C320.01 75.815 325.475 67.5557 325.085 57.6453C324.976 53.7829 323.883 50.0123 321.908 46.6907",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M300.567 55.6521C299.92 55.6891 299.291 55.8767 298.73 56.2C298.169 56.5233 297.691 56.9734 297.334 57.5142C296.978 58.055 296.753 58.6717 296.677 59.3149C296.601 59.9582 296.677 60.6103 296.898 61.2191C297.119 61.8279 297.479 62.3767 297.95 62.8215C298.421 63.2663 298.989 63.595 299.61 63.7812C300.23 63.9674 300.885 64.006 301.523 63.8939C302.161 63.7818 302.764 63.5222 303.284 63.1357",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.456 58.0439C293.211 56.4753 292.635 45.2866 298.082 41.5339C303.39 37.8723 319.701 35.1033 326.613 30.0203",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.184 40.2125C323.774 39.0555 328.684 32.3258 329.468 30.5015",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M327.051 42.8081C328.784 40.9404 329.984 37.7381 330.517 35.5627",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.085 56.0528C316.176 55.4348 315.814 54.8698 315.276 54.7908C314.739 54.7118 314.23 55.1487 314.139 55.7667C314.048 56.3847 314.41 56.9498 314.948 57.0288C315.485 57.1077 315.994 56.6708 316.085 56.0528Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.338 54.5427C319.381 55.7647 320.105 59.1274 321.479 62.0741",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.972 67.1138C316.469 66.9999 316.002 66.7617 315.615 66.4211C315.227 66.0805 314.931 65.6483 314.754 65.1638",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M301.459 180.947L319.944 316.61H331.947L337.581 172.67C335.696 175.937 316.946 179.395 301.459 180.947Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M301.458 240.048C304.002 238.098 313.99 213.654 314.246 211.552C314.449 209.867 309.57 188.607 307.629 180.248C294.698 181.878 282.188 182.441 280.719 180.829C280.719 180.829 273.851 242.449 276.251 249.348C278.652 256.246 346.451 301.244 346.451 301.244L352.751 292.846L301.458 240.048Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M351.634 293.261L361.731 299.905L354.819 325.797L351.461 301.898L347.297 299.224",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M331.034 316.61V329.362H306.078L323.476 320.969V316.255",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogging);
export default __webpack_public_path__ + "static/media/blogging.2ee690b71463b1a5263f7a9bd8b87214.svg";
export { ForwardRef as ReactComponent };